import React, { useState, useEffect } from "react";
import axios from "axios";

const ServiceContent1=({ title })=>{
     const [services, setServices] = useState([]);

     useEffect(() => {
        const fetchFilteredServices = async () => {
          try {
            const response = await axios.get(
              "https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getServiceContent",
              {
                params: { title },
              }
            );
            setServices(response.data);
            console.log("responseofservice1:", response.data);
          } catch (error) {
            console.error("Error fetching services:", error);
          }
        };
    
        fetchFilteredServices();
      }, [title]);

    return(
        <>
             <div className="ftco-section">
      <div className="container">
        <div className="row justify-content-center pb-5">
          <div className="col-md-7 text-center heading-section ftco-animate">
            <h2 className="mb-2">
              {services.title}
            </h2>
            <p>
              {services.description}
            </p>
          </div>
        </div>

          <div id="content">
         
              <div className="row servicecontent1data">
              {services.subtitles2?.map((item, index) => (
                <div key={item.subtitle_id || index} className="col-md-3 d-flex align-self-stretch ftco-animate">
                    <div className="media block-6 servicesdisplaycontent d-block text-center">
                    <div className="icon d-flex justify-content-center align-items-center">
                        <img
                        src={item.subimage || "default-image-url"} // Provide a fallback image
                        alt={item.subtitle || "Default Title"}
                        className="service-icon"
                        />
                    </div>
                    <div className="media-body p-2 mt-3">
                        <h3 className="heading">{item.subtitle || "Default Title"}</h3>
                        <p className="text-justify" style={{ textAlign: "justify" }}>
                        {item.subdescription || "No description available"}
                        </p>
                    </div>
                    </div>
                </div>
                ))}

              </div>
          
          </div>
        </div>
      </div>
   
        </>
    );
}

export default ServiceContent1;